
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a70607658 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b854934742 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b413374998 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a621761393 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a198974942 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), v0 = !s[1];
  return (n == 1 && v0) ? 'one' : 'other';
});
Globalize.b683107819 = messageFormatterFn((function(  ) {
  return function(d) { return "Reizen: Vakanties, Goedkope vluchten en Vliegtickets"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a637725059 = messageFormatterFn((function(  ) {
  return function(d) { return "Punten toegepast"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b284924762 = messageFormatterFn((function(  ) {
  return function(d) { return "Punten niet toegepast"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1199466646 = messageFormatterFn((function(  ) {
  return function(d) { return "Venster sluiten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b2040082771 = messageFormatterFn((function(  ) {
  return function(d) { return "Naar"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a37105517 = messageFormatterFn((function(  ) {
  return function(d) { return "Inchecken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1847307138 = messageFormatterFn((function(  ) {
  return function(d) { return "Uitchecken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a693685867 = messageFormatterFn((function(  ) {
  return function(d) { return "Datum"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2007767083 = messageFormatterFn((function(  ) {
  return function(d) { return "Gasten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a729031099 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoeken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a673790277 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer info over " + d["0"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1474844770 = messageFormatterFn((function(  ) {
  return function(d) { return "Opent " + d["0"] + " in een nieuw tabblad. Ga terug naar het oorspronkelijke tabblad om verder te gaan."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a640734397 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoekresultaten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1867777970 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer een bestemming in"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b671198348 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer een geldige incheckdatum"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a336260043 = messageFormatterFn((function(  ) {
  return function(d) { return "Datums voor je reis selecteren"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a802599153 = messageFormatterFn((function(  ) {
  return function(d) { return "De uitcheckdatum moet na de incheckdatum vallen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1994172217 = messageFormatterFn((function(  ) {
  return function(d) { return "De uitcheckdatum moet binnen 28 dagen na de incheckdatum vallen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a189324675 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer een geldige uitcheckdatum"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a700505201 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer het aantal reizigers"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1768799738 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer de leeftijd in van het meereizende kind"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1221500726 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer de leeftijd in van de meereizende kinderen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1686785048 = messageFormatterFn((function(  ) {
  return function(d) { return "Verblijfdatums dienen tussen de reisdatums te vallen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1181442611 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteren"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1636955551 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["0"]) + " kamers";}, one: function() { return number(d["0"]) + " kamer";}, two: function() { return number(d["0"]) + " kamers";}, few: function() { return number(d["0"]) + " kamers";}, many: function() { return number(d["0"]) + " kamers";}, other: function() { return number(d["0"]) + " kamers";} }) + ", " + plural(d["1"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["1"]) + " gasten";}, one: function() { return number(d["1"]) + " gast";}, two: function() { return number(d["1"]) + " gasten";}, few: function() { return number(d["1"]) + " gasten";}, many: function() { return number(d["1"]) + " gasten";}, other: function() { return number(d["1"]) + " gasten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1171620593 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["1"]) + " gasten";}, one: function() { return number(d["1"]) + " gast";}, two: function() { return number(d["1"]) + " gasten";}, few: function() { return number(d["1"]) + " gasten";}, many: function() { return number(d["1"]) + " gasten";}, other: function() { return number(d["1"]) + " gasten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1987670029 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["1"]) + " gasten";}, one: function() { return number(d["1"]) + " gast";}, two: function() { return number(d["1"]) + " gasten";}, few: function() { return number(d["1"]) + " gasten";}, many: function() { return number(d["1"]) + " gasten";}, other: function() { return number(d["1"]) + " gasten";} }) + ", huisdieren"; }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.b419066580 = messageFormatterFn((function(  ) {
  return function(d) { return "Gasten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a601999776 = messageFormatterFn((function(  ) {
  return function(d) { return "Kamer " + d["0"] + " toegevoegd. Bewerk hieronder de gastengegevens."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2064408000 = messageFormatterFn((function(  ) {
  return function(d) { return "Kamer verwijderd. Bewerk hieronder de gastengegevens voor kamer " + d["0"] + "."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a925378844 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuleren, sluit de Reizigerskeuze zonder de wijzigingen op te slaan. Of bewerk de onderstaande gastengegevens."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b560234020 = messageFormatterFn((function(  ) {
  return function(d) { return "Gereed"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1759219228 = messageFormatterFn((function(  ) {
  return function(d) { return "Bewaar de wijzigingen en sluit de Reizigerskeuze."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b723457912 = messageFormatterFn((function(  ) {
  return function(d) { return "Nog een kamer toevoegen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a605571545 = messageFormatterFn((function(  ) {
  return function(d) { return "Kamer verwijderen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1059916959 = messageFormatterFn((function(  ) {
  return function(d) { return "Kamer " + d["0"] + " van " + d["1"] + " verwijderen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a24915809 = messageFormatterFn((function(  ) {
  return function(d) { return "Leeftijd kind " + d["0"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1833195001 = messageFormatterFn((function(  ) {
  return function(d) { return "Kamer " + d["0"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1669811814 = messageFormatterFn((function(  ) {
  return function(d) { return "Kamer " + d["0"] + " van " + d["1"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1547412392 = messageFormatterFn((function(  ) {
  return function(d) { return "Kind " + d["0"] + ", Leeftijd is nu " + d["1"] + "."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b883774338 = messageFormatterFn((function(  ) {
  return function(d) { return "< 1"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2045132944 = messageFormatterFn((function(  ) {
  return function(d) { return "Kinderen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1986239929 = messageFormatterFn((function(  ) {
  return function(d) { return "(0-17 jaar)"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a492724154 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["0"]) + " volwassenen";}, one: function() { return number(d["0"]) + " volwassene";}, two: function() { return number(d["0"]) + " volwassenen";}, few: function() { return number(d["0"]) + " volwassenen";}, many: function() { return number(d["0"]) + " volwassenen";}, other: function() { return number(d["0"]) + " volwassenen";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2132735168 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["0"]) + " kinderen";}, one: function() { return number(d["0"]) + " kind";}, two: function() { return number(d["0"]) + " kinderen";}, few: function() { return number(d["0"]) + " kinderen";}, many: function() { return number(d["0"]) + " kinderen";}, other: function() { return number(d["0"]) + " kinderen";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.a333675926 = messageFormatterFn((function(  ) {
  return function(d) { return "Volwassenen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1961494766 = messageFormatterFn((function(  ) {
  return function(d) { return "Aantal kinderen in kamer " + d["0"] + " verlagen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1154290536 = messageFormatterFn((function(  ) {
  return function(d) { return "Aantal volwassenen in kamer " + d["0"] + " verlagen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1195277074 = messageFormatterFn((function(  ) {
  return function(d) { return "Aantal kinderen in kamer " + d["0"] + " verhogen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a518013300 = messageFormatterFn((function(  ) {
  return function(d) { return "Aantal volwassenen in kamer " + d["0"] + " verhogen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b244108448 = messageFormatterFn((function(  ) {
  return function(d) { return "Huisdieren"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a999938300 = messageFormatterFn((function(  ) {
  return function(d) { return "Huisdieren inbegrepen?"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b2019646864 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1163437858 = messageFormatterFn((function(  ) {
  return function(d) { return "Nee"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1568631828 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is opgeslagen in je lijsten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1126770662 = messageFormatterFn((function(  ) {
  return function(d) { return "Opent een nieuw venster"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b362642299 = messageFormatterFn((function(  ) {
  return function(d) { return "Gastenbeoordelingen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b282087709 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuleren, ga terug naar hoteldetails."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a880628565 = messageFormatterFn((function(  ) {
  return function(d) { return "Beschikbaarheid controleren"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a148365952 = messageFormatterFn((function(  ) {
  return function(d) { return "Tarieven controleren"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a326344910 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoekopdracht wijzigen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b163444785 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer een latere incheckdatum"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a890988587 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer een eerdere incheckdatum"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b316570128 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer een latere uitcheckdatum"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a737863244 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer een eerdere uitcheckdatum"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b191282502 = messageFormatterFn((function(  ) {
  return function(d) { return "De prijs was " + d["0"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a334867444 = messageFormatterFn((function(  ) {
  return function(d) { return "De prijs is " + d["0"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a509517849 = messageFormatterFn((function(  ) {
  return function(d) { return "De huidige prijs is " + d["0"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a115141159 = messageFormatterFn((function(  ) {
  return function(d) { return "De prijs was " + d["0"] + ", de prijs is nu " + d["1"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a4078944 = messageFormatterFn((function(  ) {
  return function(d) { return "per nacht"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1712750768 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuleren, ga terug naar hoteldetails."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b880826584 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer info"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1928489522 = messageFormatterFn((function(  ) {
  return function(d) { return "Sluiten, ga terug naar hoteldetails."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b400682404 = messageFormatterFn((function(  ) {
  return function(d) { return "Er deed zich een fout voor."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1572878186 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer een nieuwe zoekopdracht."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a367841359 = messageFormatterFn((function(  ) {
  return function(d) { return "Misschien vind je dit ook leuk"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a805300866 = messageFormatterFn((function(  ) {
  return function(d) { return "Filters sluiten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1403036170 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorteeropties & filters"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1316897260 = messageFormatterFn((function(  ) {
  return function(d) { return "Gereed"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1119876585 = messageFormatterFn((function(  ) {
  return function(d) { return "Wissen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1409006930 = messageFormatterFn((function(  ) {
  return function(d) { return "Klik op toepassen of ga terug om filters te sluiten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1092010288 = messageFormatterFn((function(  ) {
  return function(d) { return "Minimumprijs"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a212852674 = messageFormatterFn((function(  ) {
  return function(d) { return "Maximumprijs"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b413729671 = messageFormatterFn((function(  ) {
  return function(d) { return "Sterrenclassificatie"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1487628472 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorteren op"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2126014039 = messageFormatterFn((function(  ) {
  return function(d) { return "Filter op"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1074304745 = messageFormatterFn((function(  ) {
  return function(d) { return "Terug naar zoekresultaten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b679053939 = messageFormatterFn((function(  ) {
  return function(d) { return "We zoeken door duizenden accommodaties"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a753093176 = messageFormatterFn((function(  ) {
  return function(d) { return "Aan het zoeken naar duizenden pakketdeals"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b990887428 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["0"]) + " filters";}, one: function() { return number(d["0"]) + " filter";}, two: function() { return number(d["0"]) + " filters";}, few: function() { return number(d["0"]) + " filters";}, many: function() { return number(d["0"]) + " filters";}, other: function() { return number(d["0"]) + " filters";} }) + " toegepast"; }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1036833404 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorteeropties & filters"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b44758064 = messageFormatterFn((function(  ) {
  return function(d) { return "Filter"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1856896483 = messageFormatterFn((function(  ) {
  return function(d) { return "Kaart"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b178100166 = messageFormatterFn((function(  ) {
  return function(d) { return "resultaten worden geladen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a36412123 = messageFormatterFn((function(  ) {
  return function(d) { return "resultaten bijgewerkt"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1930748971 = messageFormatterFn((function(  ) {
  return function(d) { return "fout bij het ophalen van resultaten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1478818007 = messageFormatterFn((function(  ) {
  return function(d) { return "resultaten zijn leeg"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b160920747 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels zoeken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1184499236 = messageFormatterFn((function(  ) {
  return function(d) { return "Sluiten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1182056113 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer in plaats daarvan deze datums"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2080680629 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer datums tonen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2042859513 = messageFormatterFn((function(  ) {
  return function(d) { return "Minder datums tonen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1595083018 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotelzoekresultaten in " + d["0"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1344689239 = messageFormatterFn((function(  ) {
  return function(d) { return "Ongeldige hotelzoekresultaten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1219797931 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer weergeven"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1225214351 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, we konden geen resultaten vinden.  Probeer je zoekopdracht aan te passen."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b256881753 = messageFormatterFn((function(  ) {
  return function(d) { return "Geselecteerde filter"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2090157897 = messageFormatterFn((function(  ) {
  return function(d) { return "Geselecteerde filters"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b210606647 = messageFormatterFn((function(  ) {
  return function(d) { return "Bestemming ontbreekt"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1045729195 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a840710261 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle filters verwijderen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a408832564 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["0"]) + " gasten";}, one: function() { return number(d["0"]) + " gast";}, two: function() { return number(d["0"]) + " gasten";}, few: function() { return number(d["0"]) + " gasten";}, many: function() { return number(d["0"]) + " gasten";}, other: function() { return number(d["0"]) + " gasten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.a408900556 = messageFormatterFn((function(  ) {
  return function(d) { return "Er is helaas een interne fout opgetreden"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b556276569 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer het opnieuw"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1983785551 = messageFormatterFn((function(  ) {
  return function(d) { return "Sla " + d["0"] + " op in jouw lijsten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a477270567 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwijder " + d["0"] + " uit jouw lijsten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1837326321 = messageFormatterFn((function(  ) {
  return function(d) { return "Details van je volgende verblijf"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b578505882 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoek in dit gebied"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b2109788660 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, er ging iets mis. Voer de zoekopdracht nogmaals uit."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1018564901 = messageFormatterFn((function(  ) {
  return function(d) { return "Kaart sluiten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b2053664291 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["0"]) + " accommodaties";}, one: function() { return number(d["0"]) + " accommodatie";}, two: function() { return number(d["0"]) + " accommodaties";}, few: function() { return number(d["0"]) + " accommodaties";}, many: function() { return number(d["0"]) + " accommodaties";}, other: function() { return number(d["0"]) + " accommodaties";} }) + "\nvanaf " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1772515014 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["0"]) + " accommodaties";}, one: function() { return number(d["0"]) + " accommodatie";}, two: function() { return number(d["0"]) + " accommodaties";}, few: function() { return number(d["0"]) + " accommodaties";}, many: function() { return number(d["0"]) + " accommodaties";}, other: function() { return number(d["0"]) + " accommodaties";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.b667203411 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer bekijken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a995864128 = messageFormatterFn((function(  ) {
  return function(d) { return "Minder bekijken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1230971858 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, er deed zich een interne fout voor"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2127101726 = messageFormatterFn((function(  ) {
  return function(d) { return "Volgend item"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a19273122 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorig item"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1814905147 = messageFormatterFn((function(  ) {
  return function(d) { return "Afrekenen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b2102905882 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Je reis (" + plural(d["0"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["0"]) + " kamers";}, one: function() { return number(d["0"]) + " kamer";}, two: function() { return number(d["0"]) + " kamers";}, few: function() { return number(d["0"]) + " kamers";}, many: function() { return number(d["0"]) + " kamers";}, other: function() { return number(d["0"]) + " kamers";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.b278233551 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Je reis (" + plural(d["0"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["0"]) + " accommodaties";}, one: function() { return number(d["0"]) + " accommodatie";}, two: function() { return number(d["0"]) + " accommodaties";}, few: function() { return number(d["0"]) + " accommodaties";}, many: function() { return number(d["0"]) + " accommodaties";}, other: function() { return number(d["0"]) + " accommodaties";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2121904043 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer je volgende kamer"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b411391928 = messageFormatterFn((function(  ) {
  return function(d) { return "Niet meer beschikbaar"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a376753324 = messageFormatterFn((function(  ) {
  return function(d) { return "Een of meer van de accommodaties in je reisplan zijn niet meer beschikbaar. Toch afrekenen?"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1464952051 = messageFormatterFn((function(  ) {
  return function(d) { return "per kamer"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1739659771 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["0"]) + " gasten";}, one: function() { return number(d["0"]) + " gast";}, two: function() { return number(d["0"]) + " gasten";}, few: function() { return number(d["0"]) + " gasten";}, many: function() { return number(d["0"]) + " gasten";}, other: function() { return number(d["0"]) + " gasten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1175652383 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["0"]) + " kamers";}, one: function() { return number(d["0"]) + " kamer";}, two: function() { return number(d["0"]) + " kamers";}, few: function() { return number(d["0"]) + " kamers";}, many: function() { return number(d["0"]) + " kamers";}, other: function() { return number(d["0"]) + " kamers";} }) + ", " + plural(d["1"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["1"]) + " gasten";}, one: function() { return number(d["1"]) + " gast";}, two: function() { return number(d["1"]) + " gasten";}, few: function() { return number(d["1"]) + " gasten";}, many: function() { return number(d["1"]) + " gasten";}, other: function() { return number(d["1"]) + " gasten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1295350100 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/nacht"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a358609804 = messageFormatterFn((function(  ) {
  return function(d) { return "Kamer wijzigen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1277552792 = messageFormatterFn((function(  ) {
  return function(d) { return "Code is naar het klembord gekopieerd."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b408976703 = messageFormatterFn((function(  ) {
  return function(d) { return "Er is helaas een interne fout opgetreden"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b387033218 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer opnieuw te zoeken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b825782424 = messageFormatterFn((function(  ) {
  return function(d) { return "Opnieuw proberen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1954797525 = messageFormatterFn((function(  ) {
  return function(d) { return "Ophalen en inleveren van huurauto"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1852889268 = messageFormatterFn((function(  ) {
  return function(d) { return "Ophaaltijd"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b2091376736 = messageFormatterFn((function(  ) {
  return function(d) { return "Inlevertijd"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1422385089 = messageFormatterFn((function(  ) {
  return function(d) { return "Autoverhuur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1532349996 = messageFormatterFn((function(  ) {
  return function(d) { return "De inlevertijd dient minstens 2 uur na de ophaaltijd te vallen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a124531544 = messageFormatterFn((function(  ) {
  return function(d) { return "00.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a124620917 = messageFormatterFn((function(  ) {
  return function(d) { return "00.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a125455065 = messageFormatterFn((function(  ) {
  return function(d) { return "01.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a125544438 = messageFormatterFn((function(  ) {
  return function(d) { return "01.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a126378586 = messageFormatterFn((function(  ) {
  return function(d) { return "02.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a126467959 = messageFormatterFn((function(  ) {
  return function(d) { return "02.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a127302107 = messageFormatterFn((function(  ) {
  return function(d) { return "03.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a127391480 = messageFormatterFn((function(  ) {
  return function(d) { return "03.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a128225628 = messageFormatterFn((function(  ) {
  return function(d) { return "04.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a128315001 = messageFormatterFn((function(  ) {
  return function(d) { return "04.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a129149149 = messageFormatterFn((function(  ) {
  return function(d) { return "05.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a129238522 = messageFormatterFn((function(  ) {
  return function(d) { return "05.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a130072670 = messageFormatterFn((function(  ) {
  return function(d) { return "06.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a130162043 = messageFormatterFn((function(  ) {
  return function(d) { return "06.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a130996191 = messageFormatterFn((function(  ) {
  return function(d) { return "07.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a131085564 = messageFormatterFn((function(  ) {
  return function(d) { return "07.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a131919712 = messageFormatterFn((function(  ) {
  return function(d) { return "08.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a132009085 = messageFormatterFn((function(  ) {
  return function(d) { return "08.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a132843233 = messageFormatterFn((function(  ) {
  return function(d) { return "09.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a132932606 = messageFormatterFn((function(  ) {
  return function(d) { return "09.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a153160695 = messageFormatterFn((function(  ) {
  return function(d) { return "10.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a153250068 = messageFormatterFn((function(  ) {
  return function(d) { return "10.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a154084216 = messageFormatterFn((function(  ) {
  return function(d) { return "11.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a154173589 = messageFormatterFn((function(  ) {
  return function(d) { return "11.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a155007737 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a155097110 = messageFormatterFn((function(  ) {
  return function(d) { return "12.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a155931258 = messageFormatterFn((function(  ) {
  return function(d) { return "13.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a156020631 = messageFormatterFn((function(  ) {
  return function(d) { return "13.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a156854779 = messageFormatterFn((function(  ) {
  return function(d) { return "14.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a156944152 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a157778300 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a157867673 = messageFormatterFn((function(  ) {
  return function(d) { return "15.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a158701821 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a158791194 = messageFormatterFn((function(  ) {
  return function(d) { return "16.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a159625342 = messageFormatterFn((function(  ) {
  return function(d) { return "17.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a159714715 = messageFormatterFn((function(  ) {
  return function(d) { return "17.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a160548863 = messageFormatterFn((function(  ) {
  return function(d) { return "18.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a160638236 = messageFormatterFn((function(  ) {
  return function(d) { return "18.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a161472384 = messageFormatterFn((function(  ) {
  return function(d) { return "19.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a161561757 = messageFormatterFn((function(  ) {
  return function(d) { return "19.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a181789846 = messageFormatterFn((function(  ) {
  return function(d) { return "20.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a181879219 = messageFormatterFn((function(  ) {
  return function(d) { return "20.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a182713367 = messageFormatterFn((function(  ) {
  return function(d) { return "21.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a182802740 = messageFormatterFn((function(  ) {
  return function(d) { return "21.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a183636888 = messageFormatterFn((function(  ) {
  return function(d) { return "22.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a183726261 = messageFormatterFn((function(  ) {
  return function(d) { return "22.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a184560409 = messageFormatterFn((function(  ) {
  return function(d) { return "23.00 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a184649782 = messageFormatterFn((function(  ) {
  return function(d) { return "23.30 uur"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1818493671 = messageFormatterFn((function(  ) {
  return function(d) { return "Alleen rechtstreekse vluchten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1623472404 = messageFormatterFn((function(  ) {
  return function(d) { return "Voorkeursklasse"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b170723116 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a23864243 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium Economy"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b108495156 = messageFormatterFn((function(  ) {
  return function(d) { return "Business Class"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b769886988 = messageFormatterFn((function(  ) {
  return function(d) { return "First Class"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b225830453 = messageFormatterFn((function(  ) {
  return function(d) { return "Gasten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1438443159 = messageFormatterFn((function(  ) {
  return function(d) { return "Er dient minstens 1 reiziger (6 jaar of ouder) per baby op schoot te zijn."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1544585170 = messageFormatterFn((function(  ) {
  return function(d) { return "Baby’s"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1814264411 = messageFormatterFn((function(  ) {
  return function(d) { return "(2-17 jaar)"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b2001010889 = messageFormatterFn((function(  ) {
  return function(d) { return "Jonger dan 2 jaar"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a208823867 = messageFormatterFn((function(  ) {
  return function(d) { return "Leeftijd baby " + d["0"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b2033698495 = messageFormatterFn((function(  ) {
  return function(d) { return "Aantal baby's in kamer " + d["0"] + " verlagen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a138042397 = messageFormatterFn((function(  ) {
  return function(d) { return "Aantal baby's in kamer " + d["0"] + " verhogen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1443418799 = messageFormatterFn((function(  ) {
  return function(d) { return "Kinderen jonger dan 2 jaar dienen in een stoel of op schoot te zitten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1115898647 = messageFormatterFn((function(  ) {
  return function(d) { return "Op schoot"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b315189013 = messageFormatterFn((function(  ) {
  return function(d) { return "Op stoel"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2145864980 = messageFormatterFn((function(  ) {
  return function(d) { return "Leeftijdsreglement airline"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1621391520 = messageFormatterFn((function(  ) {
  return function(d) { return "Vertrek vanaf"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1909573992 = messageFormatterFn((function(  ) {
  return function(d) { return "Vertrekdatum"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1948476324 = messageFormatterFn((function(  ) {
  return function(d) { return "Retourdatum"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1786370370 = messageFormatterFn((function(  ) {
  return function(d) { return "Kies een vertreklocatie"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b449496348 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik heb slechts voor een deel van de reis accommodaties nodig"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1106295715 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, er is bij ons iets misgegaan. Probeer het opnieuw."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a775160273 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer nog minstens 1 accommodatie om te vergelijken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1795311570 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "/" + plural(d["1"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["1"]) + " accommodaties";}, one: function() { return number(d["1"]) + " accommodatie";}, two: function() { return number(d["1"]) + " accommodaties";}, few: function() { return number(d["1"]) + " accommodaties";}, many: function() { return number(d["1"]) + " accommodaties";}, other: function() { return number(d["1"]) + " accommodaties";} }) + " geselecteerd"; }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.a957646218 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "van " + plural(d["1"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["1"]) + " accommodaties";}, one: function() { return number(d["1"]) + " accommodatie";}, two: function() { return number(d["1"]) + " accommodaties";}, few: function() { return number(d["1"]) + " accommodaties";}, many: function() { return number(d["1"]) + " accommodaties";}, other: function() { return number(d["1"]) + " accommodaties";} }) + " geselecteerd om te vergelijken"; }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1737946648 = messageFormatterFn((function(  ) {
  return function(d) { return "Vergelijken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1538249476 = messageFormatterFn((function(  ) {
  return function(d) { return "Geselecteerde accommodaties vergelijken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1243385886 = messageFormatterFn((function(  ) {
  return function(d) { return "Vergelijken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a416779454 = messageFormatterFn((function(  ) {
  return function(d) { return "Geselecteerde accommodaties vergelijken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1720913840 = messageFormatterFn((function(  ) {
  return function(d) { return "Bekijken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a112982124 = messageFormatterFn((function(  ) {
  return function(d) { return "Klik om de accommodatie te bekijken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1471373873 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwijderen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1974560173 = messageFormatterFn((function(  ) {
  return function(d) { return "Klik om de accommodatie uit de vergelijking te verwijderen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b647989982 = messageFormatterFn((function(  ) {
  return function(d) { return "Sluiten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a171205030 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuleren"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a695336308 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwijderen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a703188206 = messageFormatterFn((function(  ) {
  return function(d) { return "Gereed"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b218443472 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwijderen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2071664967 = messageFormatterFn((function(  ) {
  return function(d) { return "geselecteerd"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1934509990 = messageFormatterFn((function(  ) {
  return function(d) { return "Laden"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b657748937 = messageFormatterFn((function(  ) {
  return function(d) { return "Wissen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1653520207 = messageFormatterFn((function(  ) {
  return function(d) { return "Opent in een nieuw venster"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a248154059 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer weergeven"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a51771864 = messageFormatterFn((function(  ) {
  return function(d) { return "Minder weergeven"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b422591220 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer bekijken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b289346855 = messageFormatterFn((function(  ) {
  return function(d) { return "Minder bekijken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b340990542 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " geselecteerd. Kies nu een uitcheckdatum."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1934619167 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " geselecteerd. Kies Gereed om deze datums op te slaan en de kalender te sluiten."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1796212995 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", huidige incheckdatum"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a590054398 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", huidige uitcheckdatum"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1204059476 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", datum uitgeschakeld"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a604176913 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", huidige maand"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1052582644 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " en " + d["1"] + " worden nu getoond"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1630240056 = messageFormatterFn((function(  ) {
  return function(d) { return "kalender geopend. Selecteer een datum uit de onderstaande tabellen."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b863467434 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuleren, sluit de kalender zonder je wijzigingen op te slaan. Of selecteer een datum uit de onderstaande tabellen."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1733489094 = messageFormatterFn((function(  ) {
  return function(d) { return "Wis de geselecteerde datums."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a839019345 = messageFormatterFn((function(  ) {
  return function(d) { return "Sla de wijzigingen op en sluit de kalender."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b846532950 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["0"]) + " nachten";}, one: function() { return number(d["0"]) + " nacht";}, two: function() { return number(d["0"]) + " nachten";}, few: function() { return number(d["0"]) + " nachten";}, many: function() { return number(d["0"]) + " nachten";}, other: function() { return number(d["0"]) + " nachten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.a508016122 = messageFormatterFn((function(  ) {
  return function(d) { return "Inchecken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b464959605 = messageFormatterFn((function(  ) {
  return function(d) { return "Uitchecken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a478088148 = messageFormatterFn((function(  ) {
  return function(d) { return "Datums wissen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a113735403 = messageFormatterFn((function(  ) {
  return function(d) { return "Gereed"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a305714897 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoeken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1293300679 = messageFormatterFn((function(  ) {
  return function(d) { return "Bewerk de incheckdatum in de onderstaande tabellen."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b670268584 = messageFormatterFn((function(  ) {
  return function(d) { return "Bewerk de uitcheckdatum in de onderstaande tabellen."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b5712871 = messageFormatterFn((function(  ) {
  return function(d) { return "geselecteerd."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a696069492 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " geselecteerd. Sluit de kalender of ga verder met het wijzigen van de geselecteerde datum."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b804313476 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " tot " + d["1"] + " geselecteerd. Sluit de kalender of ga verder met het wijzigen van de geselecteerde datums."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1091324610 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " geselecteerd. " + d["1"] + ". Sluit de kalender of ga verder met het wijzigen van de geselecteerde datum."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1078732874 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " tot " + d["1"] + " geselecteerd. " + d["2"] + ". Sluit de kalender of ga verder met het wijzigen van de geselecteerde datums."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1889658077 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer incheckdatum"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1333818454 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecteer uitcheckdatum"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1116064837 = messageFormatterFn((function(  ) {
  return function(d) { return "leeg"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1399151331 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorige maand"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a364995271 = messageFormatterFn((function(  ) {
  return function(d) { return "Volgende maand"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2064571112 = messageFormatterFn((function(  ) {
  return function(d) { return "Ga direct naar de knop " + d["0"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1444217024 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " tot en met " + d["1"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a691782717 = messageFormatterFn((function(  ) {
  return function(d) { return "Datums zijn gewist"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1798326352 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "er " + plural(d["0"], 0, pluralFuncs["nl-NL"], { zero: function() { return "zijn " + number(d["0"]) + " resultaten";}, one: function() { return "is " + number(d["0"]) + " resultaat";}, two: function() { return "zijn " + number(d["0"]) + " resultaten";}, few: function() { return "zijn " + number(d["0"]) + " resultaten";}, many: function() { return "zijn " + number(d["0"]) + " resultaten";}, other: function() { return "zijn " + number(d["0"]) + " resultaten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.b872986457 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "er " + plural(d["1"], 0, pluralFuncs["nl-NL"], { zero: function() { return "zijn " + number(d["1"]) + " resultaten";}, one: function() { return "is " + number(d["1"]) + " resultaat";}, two: function() { return "zijn " + number(d["1"]) + " resultaten";}, few: function() { return "zijn " + number(d["1"]) + " resultaten";}, many: function() { return "zijn " + number(d["1"]) + " resultaten";}, other: function() { return "zijn " + number(d["1"]) + " resultaten";} }) + " beschikbaar voor " + d["0"] + ". Gebruik de pijltjestoetsen of swipe om door de lijst te gaan."; }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1934673741 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoekopdracht voor " + d["0"] + " geopend, voer zoekterm in."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1686303294 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt " + d["0"] + " geselecteerd."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2082637215 = messageFormatterFn((function(  ) {
  return function(d) { return "Het menu is gesloten."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1127056485 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Zoekopdracht voor " + d["0"] + " geopend. " + plural(d["1"], 0, pluralFuncs["nl-NL"], { zero: function() { return "Er worden momenteel " + number(d["1"]) + " suggesties";}, one: function() { return "Er wordt momenteel " + number(d["1"]) + " suggestie";}, two: function() { return "Er worden momenteel " + number(d["1"]) + " suggesties";}, few: function() { return "Er worden momenteel " + number(d["1"]) + " suggesties";}, many: function() { return "Er worden momenteel " + number(d["1"]) + " suggesties";}, other: function() { return "Er worden momenteel " + number(d["1"]) + " suggesties";} }) + " voor " + d["2"] + " weergegeven. Navigeer naar de onderstaande lijst."; }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.a120722226 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Zoekopdracht voor " + d["0"] + " geopend. " + plural(d["1"], 0, pluralFuncs["nl-NL"], { zero: function() { return "Er worden " + number(d["1"]) + " suggesties";}, one: function() { return "Er wordt " + number(d["1"]) + " suggestie";}, two: function() { return "Er worden " + number(d["1"]) + " suggesties";}, few: function() { return "Er worden " + number(d["1"]) + " suggesties";}, many: function() { return "Er worden " + number(d["1"]) + " suggesties";}, other: function() { return "Er worden " + number(d["1"]) + " suggesties";} }) + " weergegeven. Voer een zoekterm in of navigeer naar de onderstaande lijst."; }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.a380630418 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Zoekopdracht voor " + d["0"] + " geopend. Momenteel " + d["1"] + " geselecteerd. " + plural(d["2"], 0, pluralFuncs["nl-NL"], { zero: function() { return "Er worden " + number(d["2"]) + " suggesties";}, one: function() { return "Er wordt " + number(d["2"]) + " suggestie";}, two: function() { return "Er worden " + number(d["2"]) + " suggesties";}, few: function() { return "Er worden " + number(d["2"]) + " suggesties";}, many: function() { return "Er worden " + number(d["2"]) + " suggesties";}, other: function() { return "Er worden " + number(d["2"]) + " suggesties";} }) + " voor " + d["3"] + " weergegeven. Navigeer naar de onderstaande lijst."; }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.b673082092 = messageFormatterFn((function(  ) {
  return function(d) { return "Gereed"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1080903755 = messageFormatterFn((function(  ) {
  return function(d) { return "Alles wissen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1558773922 = messageFormatterFn((function(  ) {
  return function(d) { return "Geselecteerde items"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1742539861 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " verwijderd."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b251594610 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle selecties verwijderd."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2145891875 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt info toegevoegd aan het invoerveld. Zoek of kies uit de onderstaande categorieën."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a165128196 = messageFormatterFn((function(  ) {
  return function(d) { return "Zoeken naar ‘" + d["0"] + "’"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1677321533 = messageFormatterFn((function(  ) {
  return function(d) { return "Geen resultaten voor “" + d["0"] + "”"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a574187481 = messageFormatterFn((function(  ) {
  return function(d) { return "Luchthaven"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1711902910 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1824586520 = messageFormatterFn((function(  ) {
  return function(d) { return "Bezienswaardigheid"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a37519359 = messageFormatterFn((function(  ) {
  return function(d) { return "In de buurt"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b640586946 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer ‘" + d["0"] + "’"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a14397671 = messageFormatterFn((function(  ) {
  return function(d) { return "Regio's / plaatsen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1078375717 = messageFormatterFn((function(  ) {
  return function(d) { return "Luchthavens"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1754934493 = messageFormatterFn((function(  ) {
  return function(d) { return "Bezienswaardigheden"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a760127374 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1462160910 = messageFormatterFn((function(  ) {
  return function(d) { return "Adres"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b233115576 = messageFormatterFn((function(  ) {
  return function(d) { return "Treinstation"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1793464407 = messageFormatterFn((function(  ) {
  return function(d) { return "Metrostations"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1156194117 = messageFormatterFn((function(  ) {
  return function(d) { return "Ontdek bestemmingen in de buurt"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1981845842 = messageFormatterFn((function(  ) {
  return function(d) { return "Recente zoekopdrachten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1864318292 = messageFormatterFn((function(  ) {
  return function(d) { return "Reizigers zochten ook naar"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1558814113 = messageFormatterFn((function(  ) {
  return function(d) { return "Ontdek populaire bestemmingen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b31850573 = messageFormatterFn((function(  ) {
  return function(d) { return "Populaire bestemmingen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b158226199 = messageFormatterFn((function(  ) {
  return function(d) { return "Veel gezochte bestemmingen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1791235477 = messageFormatterFn((function(  ) {
  return function(d) { return "Huidige locatie"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b2140460056 = messageFormatterFn((function(  ) {
  return function(d) { return "Locatie delen is uitgeschakeld"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1692183400 = messageFormatterFn((function(  ) {
  return function(d) { return "We kunnen je locatie niet bepalen. Schakel de locatievoorzieningen van je apparaat in zodat we je locatie kunnen bepalen of voer een bestemming in."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a784292924 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["0"]) + " kamers";}, one: function() { return number(d["0"]) + " kamer";}, two: function() { return number(d["0"]) + " kamers";}, few: function() { return number(d["0"]) + " kamers";}, many: function() { return number(d["0"]) + " kamers";}, other: function() { return number(d["0"]) + " kamers";} }) + ", " + plural(d["1"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["1"]) + " gasten";}, one: function() { return number(d["1"]) + " gast";}, two: function() { return number(d["1"]) + " gasten";}, few: function() { return number(d["1"]) + " gasten";}, many: function() { return number(d["1"]) + " gasten";}, other: function() { return number(d["1"]) + " gasten";} }); }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.a643014922 = messageFormatterFn((function(  ) {
  return function(d) { return "De waarde van het veld " + d["0"] + " is nu " + d["1"] + ". De waarde van het veld " + d["2"] + " is nu " + d["3"] + "."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a706388473 = messageFormatterFn((function(  ) {
  return function(d) { return "Wissel de velden " + d["0"] + " en " + d["1"] + " om."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a35847322 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord weergeven"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b278494817 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord verbergen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1503237016 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " wordt nu getoond"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1541057027 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " van " + d["1"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b575970343 = messageFormatterFn((function(  ) {
  return function(d) { return "Afbeelding " + d["0"] + " van " + d["1"] + ". " + d["2"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a569757334 = messageFormatterFn((function(  ) {
  return function(d) { return "Volgende afbeelding tonen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1232461678 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorige afbeelding tonen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1224011656 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle " + d["0"] + " afbeeldingen tonen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1784689939 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Toon " + plural(d["0"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["0"]) + " afbeeldingen";}, one: function() { return number(d["0"]) + " afbeelding";}, two: function() { return number(d["0"]) + " afbeeldingen";}, few: function() { return number(d["0"]) + " afbeeldingen";}, many: function() { return number(d["0"]) + " afbeeldingen";}, other: function() { return number(d["0"]) + " afbeeldingen";} }) + " voor " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1109709270 = messageFormatterFn((function(  ) {
  return function(d) { return "Voltooid:"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1015473448 = messageFormatterFn((function(  ) {
  return function(d) { return "Huidig:"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b527698426 = messageFormatterFn((function(  ) {
  return function(d) { return "Stap " + d["0"] + " van " + d["1"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a354654166 = messageFormatterFn((function(  ) {
  return function(d) { return "Stap " + d["0"] + " van " + d["1"] + ":"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b156079465 = messageFormatterFn((function(  ) {
  return function(d) { return "Afbeelding " + d["0"] + " van " + d["1"] + ". " + d["2"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1642818772 = messageFormatterFn((function(  ) {
  return function(d) { return "Volgende afbeelding"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1444253744 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorige afbeelding"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a99830878 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", vergroten naar volledig scherm"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b597486474 = messageFormatterFn((function(  ) {
  return function(d) { return "Item " + d["0"] + ", vergroten naar volledig scherm"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a393301108 = messageFormatterFn((function(  ) {
  return function(d) { return "Huidige pagina"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a966638396 = messageFormatterFn((function(  ) {
  return function(d) { return "Meer broodkruimels weergeven"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a928817280 = messageFormatterFn((function(  ) {
  return function(d) { return "Minder broodkruimels weergeven"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b519901021 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " procent, bezig met laden"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a632308574 = messageFormatterFn((function(  ) {
  return function(d) { return "Bezig met laden"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b483859054 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " " + d["1"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a407390441 = messageFormatterFn((function(  ) {
  return function(d) { return "Er ging iets mis."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b2046891763 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer deze video op www.youtube.com te bekijken of schakel Javascript in je browser in."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b257128565 = messageFormatterFn((function(  ) {
  return function(d) { return "Video afspelen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b131835835 = messageFormatterFn((function(  ) {
  return function(d) { return "Video pauzeren"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a624186653 = messageFormatterFn((function(  ) {
  return function(d) { return "Video wordt geladen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b909218669 = messageFormatterFn((function(  ) {
  return function(d) { return "Photosphere"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b797622605 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit is een 360-graden-foto. Gebruik de Ctrl- en pijltoetsen of Cmd- en pijltoetsen om te bewegen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1825930144 = messageFormatterFn((function(  ) {
  return function(d) { return "Huidige weergave: " + d["0"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1192822591 = messageFormatterFn((function(  ) {
  return function(d) { return "Naar links bewegen. Positie: " + d["0"] + " graden"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b531990854 = messageFormatterFn((function(  ) {
  return function(d) { return "Naar rechts bewegen. Positie: " + d["0"] + " graden"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1279728659 = messageFormatterFn((function(  ) {
  return function(d) { return "Omhoog bewegen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a973525274 = messageFormatterFn((function(  ) {
  return function(d) { return "Omlaag bewegen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1993308331 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt de bovenkant bereikt"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1545581823 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt de onderkant bereikt"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1310452053 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle rijen selecteren"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1864117940 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle rijen deselecteren"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1690225348 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolom ordenen van hoog naar laag"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1656522210 = messageFormatterFn((function(  ) {
  return function(d) { return "Kolom ordenen van laag naar hoog"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a59959602 = messageFormatterFn((function(  ) {
  return function(d) { return "De kolom is nu geordend van hoog naar laag"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1944278218 = messageFormatterFn((function(  ) {
  return function(d) { return "De kolom is nu geordend van laag naar hoog"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1416006034 = messageFormatterFn((function(  ) {
  return function(d) { return "Rij " + d["0"] + " uitvouwen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1576036271 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " van " + plural(d["1"], 0, pluralFuncs["nl-NL"], { zero: function() { return number(d["1"]) + " items";}, one: function() { return number(d["1"]) + " item";}, two: function() { return number(d["1"]) + " items";}, few: function() { return number(d["1"]) + " items";}, many: function() { return number(d["1"]) + " items";}, other: function() { return number(d["1"]) + " items";} }) + " weergegeven"; }
})(messageFormat.number, messageFormat.plural, {"nl-NL": Globalize("nl-NL").pluralGenerator()}), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1563301505 = messageFormatterFn((function(  ) {
  return function(d) { return "De weergegeven maanden zijn " + d["0"] + " " + d["1"] + " en " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b913508057 = messageFormatterFn((function(  ) {
  return function(d) { return "Incheckdatum gewist."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1337802128 = messageFormatterFn((function(  ) {
  return function(d) { return "Uitcheckdatum gewist."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1284218993 = messageFormatterFn((function(  ) {
  return function(d) { return "Datums gewist."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1608002323 = messageFormatterFn((function(  ) {
  return function(d) { return "Volgende maand"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1152803795 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorige maand"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1140125454 = messageFormatterFn((function(  ) {
  return function(d) { return "Je selecteerde " + d["0"] + " als incheckdatum."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b68986455 = messageFormatterFn((function(  ) {
  return function(d) { return "Je selecteerde " + d["0"] + " als uitcheckdatum."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1334975502 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is geen geldige incheckdatum."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1144434697 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is geen geldige uitcheckdatum."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b983200806 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is niet beschikbaar."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1551079925 = messageFormatterFn((function(  ) {
  return function(d) { return "Vandaag"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1169537844 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " van " + d["1"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1647411126 = messageFormatterFn((function(  ) {
  return function(d) { return "Meld je aan bij " + d["0"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a891418883 = messageFormatterFn((function(  ) {
  return function(d) { return "Welkom terug! Meld je aan via"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1269383433 = messageFormatterFn((function(  ) {
  return function(d) { return "Welkom terug! Meld je aan en bespaar ten minste 10% extra op duizenden accommodaties met ledenprijzen."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1899376675 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadres"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1832959542 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1797167239 = messageFormatterFn((function(  ) {
  return function(d) { return "Een account nodig?"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a596418453 = messageFormatterFn((function(  ) {
  return function(d) { return "We melden je aan..."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2006097896 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden via Facebook"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1098887259 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden via Google"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a434395765 = messageFormatterFn((function(  ) {
  return function(d) { return "Houd me aangemeld"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1643899982 = messageFormatterFn((function(  ) {
  return function(d) { return "Houd me aangemeld (gebruikt cookies)"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1314859268 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1315218682 = messageFormatterFn((function(  ) {
  return function(d) { return "Registreren"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b892247018 = messageFormatterFn((function(  ) {
  return function(d) { return "Of <a href=\"" + d["0"] + "\">meld je aan via Facebook</a>"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1294246368 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord vergeten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1036809165 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je e-mailadres in"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1563376119 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer een geldig e-mailadres in."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1853598650 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je wachtwoord in"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1619469248 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer het opnieuw"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1697486980 = messageFormatterFn((function(  ) {
  return function(d) { return "Oeps, er is iets fout gelopen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a76140898 = messageFormatterFn((function(  ) {
  return function(d) { return "Corrigeer de onderstaande fout om door te gaan"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b2049442375 = messageFormatterFn((function(  ) {
  return function(d) { return "Corrigeer de twee onderstaande fouten om door te gaan"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1018697551 = messageFormatterFn((function(  ) {
  return function(d) { return "Meld je aan met je e-mailadres"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1357744898 = messageFormatterFn((function(  ) {
  return function(d) { return "Of meld je aan met je e-mailadres"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1826840071 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadres"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a427689894 = messageFormatterFn((function(  ) {
  return function(d) { return "of"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1365246936 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord vergeten?"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b286026859 = messageFormatterFn((function(  ) {
  return function(d) { return "Geen lid?"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1704297761 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een account aan"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1027755568 = messageFormatterFn((function(  ) {
  return function(d) { return "Door me aan te melden, ga ik akkoord met de <a href=\"" + d["0"] + "\" target=\"_blank\">Voorwaarden & Bepalingen van " + d["1"] + ". <span class=\"is-visually-hidden\">opent in een nieuw venster</span></a>"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1158062170 = messageFormatterFn((function(  ) {
  return function(d) { return "Door me aan te melden bij mijn " + d["0"] + "-account ga ik akkoord met de <a href=\"" + d["1"] + "\" target=\"_blank\">Gebruiksvoorwaarden van " + d["2"] + "<span class=\"is-visually-hidden\">opent in een nieuw venster</span></a>, het <a href=\"" + d["3"] + "\" target=\"_blank\">Privacybeleid<span class=\"is-visually-hidden\">opent in een nieuw venster</span></a> en de <a href=\"" + d["4"] + "\" target=\"_blank\">Voorwaarden & Bepalingen van " + d["5"] + "<span class=\"is-visually-hidden\">opent in een nieuw venster</span></a>. "; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a599086410 = messageFormatterFn((function(  ) {
  return function(d) { return "Registreer je bij <a href=\"" + d["0"] + "\" target=\"_blank\">" + d["1"] + ". <span class=\"is-visually-hidden\">opent in een nieuw venster</span></a> Door me te registreren ga ik akkoord met alle <a href=\"" + d["3"] + "\" target=\"_blank\">Voorwaarden & Bepalingen. <span class=\"is-visually-hidden\">opent in een nieuw venster</span></a>"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b496798170 = messageFormatterFn((function(  ) {
  return function(d) { return "Voorwaarden van toepassing, links beschikbaar op het einde van de pagina"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b552703508 = messageFormatterFn((function(  ) {
  return function(d) { return "Controleer je inbox!"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a739111129 = messageFormatterFn((function(  ) {
  return function(d) { return "Reset je wachtwoord met de link die we hebben gestuurd naar " + d["0"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a513465446 = messageFormatterFn((function(  ) {
  return function(d) { return "Link opnieuw versturen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a389723718 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, er deed zich een interne fout voor"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b436563265 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer het opnieuw."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1135694618 = messageFormatterFn((function(  ) {
  return function(d) { return "Terug"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1510032730 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben een nieuwe link verstuurd."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b463750336 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een account aan bij " + d["0"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1153491207 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een account aan bij"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1687011801 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een account aan met je e-mailadres"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a575557580 = messageFormatterFn((function(  ) {
  return function(d) { return "Of maak een account aan met je e-mailadres"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2008952324 = messageFormatterFn((function(  ) {
  return function(d) { return "Voor- en achternaam"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1435347134 = messageFormatterFn((function(  ) {
  return function(d) { return "Achter- en voornaam"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1778068199 = messageFormatterFn((function(  ) {
  return function(d) { return "Dient tussen 8 en 30 tekens lang te zijn en mag geen spaties bevatten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b157746665 = messageFormatterFn((function(  ) {
  return function(d) { return "Account aanmaken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1623439578 = messageFormatterFn((function(  ) {
  return function(d) { return "Heb je al een account?"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1983717658 = messageFormatterFn((function(  ) {
  return function(d) { return "Door een account aan te maken, ga ik akkoord met de " + d["0"] + "gebruiksvoorwaarden van <a href=\"" + d["1"] + "\" target=\"_blank\">, <span class=\"is-visually-hidden\">opent in een nieuw venster</span></a> het <a href=\"" + d["2"] + "\" target=\"_blank\">Privacybeleid, <span class=\"is-visually-hidden\">opent in een nieuw venster</span></a> en de <a href=\"" + d["3"] + "\" target=\"_blank\">Voorwaarden & Bepalingen van " + d["4"] + ". <span class=\"is-visually-hidden\">opent in een nieuw venster</span></a>"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a362962177 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik wil e-mails ontvangen met reisaanbiedingen, speciale deals en andere informatie."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1519229195 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben je een e-mail met een link gestuurd om het aanmaken van je account te voltooien. "; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1491822218 = messageFormatterFn((function(  ) {
  return function(d) { return "Klik op de link in de e-mail die naar " + d["0"] + " is verstuurd om het aanmaken van je account te voltooien."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a946353951 = messageFormatterFn((function(  ) {
  return function(d) { return "Reset je wachtwoord"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a922655547 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je e-mailadres in en wij sturen je een link om je wachtwoord te resetten."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1434010929 = messageFormatterFn((function(  ) {
  return function(d) { return "Resetlink sturen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1257372351 = messageFormatterFn((function(  ) {
  return function(d) { return "of als gast afrekenen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1407344729 = messageFormatterFn((function(  ) {
  return function(d) { return "Kies een nieuw wachtwoord"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2076545208 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een nieuw wachtwoord aan"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1521354163 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadres: " + d["0"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1219537833 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord opslaan"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1835308699 = messageFormatterFn((function(  ) {
  return function(d) { return "Deze link is helaas niet meer geldig"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1281429264 = messageFormatterFn((function(  ) {
  return function(d) { return "Vraag een nieuwe link aan voor het resetten van je wachtwoord."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1188366768 = messageFormatterFn((function(  ) {
  return function(d) { return "Nieuwe resetlink sturen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1968705593 = messageFormatterFn((function(  ) {
  return function(d) { return "Terug naar Aanmelden"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1870781914 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben je via e-mail een nieuwe link gestuurd om je wachtwoord te resetten."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a233566383 = messageFormatterFn((function(  ) {
  return function(d) { return "Wat is je e-mailadres?"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b974631756 = messageFormatterFn((function(  ) {
  return function(d) { return "Geef een e-mailadres op waarop je reisaanbieders of " + d["0"] + " je kunnen bereiken. We sturen je een beveiligingscode om je identiteit te verifiëren."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b826489721 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt je " + d["0"] + "-account met een telefoonnummer aangemaakt. Verstrek een e-mailadres zodat we je registratie kunnen voltooien. We sturen je een beveiligingscode om je identiteit te verifiëren."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b718137478 = messageFormatterFn((function(  ) {
  return function(d) { return "Beveiligingscode verzenden"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b84268332 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer beveiligingscode in"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a134090476 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer de beveiligingscode in die we naar " + d["0"] + " hebben verstuurd."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a524243427 = messageFormatterFn((function(  ) {
  return function(d) { return "Beveiligingscode"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1035972193 = messageFormatterFn((function(  ) {
  return function(d) { return "Indienen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1358967979 = messageFormatterFn((function(  ) {
  return function(d) { return "Geen e-mail ontvangen?"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b313183153 = messageFormatterFn((function(  ) {
  return function(d) { return "Nieuwe beveiligingscode verzenden"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2006327916 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben een nieuwe beveiligingscode via e-mail naar je verstuurd."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1268674511 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer een geldige beveiligingscode in"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a97777110 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt te vaak geprobeerd om de beveiligingscode opnieuw te verzenden. Probeer het na 24 uur opnieuw."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1134796436 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt te vaak geprobeerd om de juiste beveiligingscode in te voeren. Probeer het na 24 uur opnieuw."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a312427923 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer de juiste beveiligingscode in"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b210107415 = messageFormatterFn((function(  ) {
  return function(d) { return "Het door jou ingevoerde e-mailadres is al gebruikt om met " + d["1"] + " een account bij " + d["0"] + " aan te maken. Probeer je aan te melden met het " + d["1"] + "-account dat aan dat e-mailadres gekoppeld is."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b686557246 = messageFormatterFn((function(  ) {
  return function(d) { return "Om je account veilig te houden, dien je je wachtwoord te resetten voordat je je kunt aanmelden."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b2001472852 = messageFormatterFn((function(  ) {
  return function(d) { return "Als je een account bij " + d["0"] + " hebt, sturen we je een e-mail met een link om je wachtwoord te resetten."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b246189441 = messageFormatterFn((function(  ) {
  return function(d) { return "Welkom terug, " + d["0"] + "!"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1831936987 = messageFormatterFn((function(  ) {
  return function(d) { return "Je nieuwe wachtwoord is opgeslagen."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1098310191 = messageFormatterFn((function(  ) {
  return function(d) { return "Verder boeken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b786028641 = messageFormatterFn((function(  ) {
  return function(d) { return "Welkom " + d["0"] + "!"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1977008637 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, er deed zich een interne fout voor"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a544251340 = messageFormatterFn((function(  ) {
  return function(d) { return "Corrigeer de " + d["0"] + " onderstaande fouten om door te gaan"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b751068157 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt een onbekend e-mailadres of onjuist wachtwoord ingevoerd"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b869951813 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, we konden geen verbinding maken met " + d["0"]; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1406146438 = messageFormatterFn((function(  ) {
  return function(d) { return "Je resetlink is helaas verlopen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a734116576 = messageFormatterFn((function(  ) {
  return function(d) { return "Vraag een nieuwe link aan"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b172807578 = messageFormatterFn((function(  ) {
  return function(d) { return "Je sessie is helaas verlopen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1547506702 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je voor- en achternaam in"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b586460614 = messageFormatterFn((function(  ) {
  return function(d) { return "Voor je achter- en voornaam in"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1393926920 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer een naam in die alleen uit letters bestaat"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a118930024 = messageFormatterFn((function(  ) {
  return function(d) { return "Er bestaat al een account op " + d["0"] + " met dit e-mailadres  "; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b94844708 = messageFormatterFn((function(  ) {
  return function(d) { return "Het wachtwoord mag geen spaties bevatten."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1016607293 = messageFormatterFn((function(  ) {
  return function(d) { return "Het wachtwoord mag niet overeenkomen met je e-mailadres."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b185423897 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit wachtwoord kan makkelijk geraden worden."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1876829298 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit e-mailadres is al in gebruik"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a916894591 = messageFormatterFn((function(  ) {
  return function(d) { return "Het wachtwoord is vereist."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1238244443 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit wachtwoord is onjuist."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a684364649 = messageFormatterFn((function(  ) {
  return function(d) { return "Je wachtwoord dient uit minstens " + d["0"] + " tekens te bestaan"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a27448599 = messageFormatterFn((function(  ) {
  return function(d) { return "Het wachtwoord dient " + d["0"] + " tot " + d["1"] + " tekens te bevatten."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b830092583 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit e-mailadres is al gebruikt om een account bij " + d["0"] + " aan te maken met " + d["1"] + ". Gebruik een ander e-mailadres of meld je aan met het " + d["1"] + "-account dat aan dit e-mailadres gekoppeld is"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1813399731 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, we kunnen je Apple ID niet gebruiken om in te loggen. We werken eraan om Apple ID's te ondersteunen die uit telefoonnummers bestaan. Meld je ondertussen aan via een andere methode."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1586122967 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit account kan niet gevonden worden."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a914852872 = messageFormatterFn((function(  ) {
  return function(d) { return "Een e-mailadres is vereist."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1377312551 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden sluiten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b864526257 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een account aan sluiten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1502336460 = messageFormatterFn((function(  ) {
  return function(d) { return "Terug naar de vorige pagina"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b143154605 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailvalidatie sluiten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b975829049 = messageFormatterFn((function(  ) {
  return function(d) { return "Invoervenster voor CVV-code sluiten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b730777263 = messageFormatterFn((function(  ) {
  return function(d) { return "Voltooi je boeking als gast of meld je aan"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1173806641 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik ben een nieuwe klant"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1242526256 = messageFormatterFn((function(  ) {
  return function(d) { return "Je kunt na het afrekenen ook nog een account aanmaken."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1962388815 = messageFormatterFn((function(  ) {
  return function(d) { return "Als gast afrekenen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1582820803 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik ben een terugkerende klant"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a977767917 = messageFormatterFn((function(  ) {
  return function(d) { return "Meld je aan om punten met je boeking te verzamelen en punten voor je boeking te gebruiken."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1853628700 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden en afrekenen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a810989429 = messageFormatterFn((function(  ) {
  return function(d) { return "Of ga verder met"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b128868571 = messageFormatterFn((function(  ) {
  return function(d) { return "Welkom terug!"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1834093932 = messageFormatterFn((function(  ) {
  return function(d) { return "Meld je aan of maak een account aan"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1509169503 = messageFormatterFn((function(  ) {
  return function(d) { return "Doorgaan"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a641509187 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben een link voor het opnieuw instellen van je wachtwoord verzonden naar " + d["0"] + ". Het kan een paar minuten duren voor je de link ontvangt. Controleer je map met ongewenste e-mail of spam als je de e-mail niet in je inbox ziet."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2100241126 = messageFormatterFn((function(  ) {
  return function(d) { return "Stel je wachtwoord opnieuw in"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b725012098 = messageFormatterFn((function(  ) {
  return function(d) { return "Gebruik 8 of meer tekens voor je wachtwoord."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1648711496 = messageFormatterFn((function(  ) {
  return function(d) { return "Ga verder met een gelinkt account"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1771487390 = messageFormatterFn((function(  ) {
  return function(d) { return "of stel een wachtwoord in"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1984543080 = messageFormatterFn((function(  ) {
  return function(d) { return "Controleer je inbox!"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1667485905 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben een verificatielink naar " + d["0"] + " verzonden zodat je je accountwachtwoord kunt instellen. Het kan een paar minuten duren voor je de link ontvangt. Controleer je map met ongewenste e-mail of spam als je de e-mail niet in je inbox ziet."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1042846387 = messageFormatterFn((function(  ) {
  return function(d) { return "Stel een wachtwoord in"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1417575287 = messageFormatterFn((function(  ) {
  return function(d) { return "Bewerken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1002495051 = messageFormatterFn((function(  ) {
  return function(d) { return "Het lijkt erop dat je al eerder bij ons geboekt hebt. Om veiligheidsredenen dienen we je e-mailadres te verifiëren."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1916028969 = messageFormatterFn((function(  ) {
  return function(d) { return "Gebruik de verificatielink die we naar " + d["0"] + " verzonden hebben om het aanmaken van je account te voltooien. Het kan een paar minuten duren voor je de link ontvangt. Controleer je map met ongewenste e-mail of spam als je de e-mail niet in je inbox ziet."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a501364089 = messageFormatterFn((function(  ) {
  return function(d) { return "Mijn reizigersdetails"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1478040812 = messageFormatterFn((function(  ) {
  return function(d) { return "Mijn accountdetails"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1437424018 = messageFormatterFn((function(  ) {
  return function(d) { return "Update persoonlijke gegevens en pas voorkeuren aan."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a775837144 = messageFormatterFn((function(  ) {
  return function(d) { return "TSA-informatie"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b976852868 = messageFormatterFn((function(  ) {
  return function(d) { return "Voeg het Known Traveler- of redress-nummer toe."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b301709514 = messageFormatterFn((function(  ) {
  return function(d) { return "Persoonlijke gegevens"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1267514458 = messageFormatterFn((function(  ) {
  return function(d) { return "Deel basis- en contactgegevens."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1008628593 = messageFormatterFn((function(  ) {
  return function(d) { return "Vluchtvoorkeuren"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b527099179 = messageFormatterFn((function(  ) {
  return function(d) { return "Pas de instellingen aan om je ervaring te personaliseren."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a616809216 = messageFormatterFn((function(  ) {
  return function(d) { return "Loyaliteitsprogramma’s"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1109163100 = messageFormatterFn((function(  ) {
  return function(d) { return "Sla je frequent flyer en lidmaatschappen op"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b549727054 = messageFormatterFn((function(  ) {
  return function(d) { return "Paspoort"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2034147030 = messageFormatterFn((function(  ) {
  return function(d) { return "Sla je paspoort op om het boekingsproces te versnellen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a2115897771 = messageFormatterFn((function(  ) {
  return function(d) { return "Apparatuurbeheer"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1402883953 = messageFormatterFn((function(  ) {
  return function(d) { return "Bekijk je aangemelde apparaten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b264324247 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden om je account te bekijken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1439626918 = messageFormatterFn((function(  ) {
  return function(d) { return "Account aanmaken"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a54626983 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, er is bij ons iets misgegaan."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a69180946 = messageFormatterFn((function(  ) {
  return function(d) { return "Ben je offline? Controleer je internetverbinding en probeer het opnieuw."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a204293324 = messageFormatterFn((function(  ) {
  return function(d) { return "Opnieuw proberen"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a429025085 = messageFormatterFn((function(  ) {
  return function(d) { return "Bezig met laden ..."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a1795529698 = messageFormatterFn((function(  ) {
  return function(d) { return "1 nacht"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b719872022 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " nachten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b870902570 = messageFormatterFn((function(  ) {
  return function(d) { return "Gereed, 1 nacht geselecteerd. Sla de wijzigingen op en sluit de kalender."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.a869055838 = messageFormatterFn((function(  ) {
  return function(d) { return "Gereed, " + d["0"] + " nachten geselecteerd. Sla de wijzigingen op en sluit de kalender."; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1132926117 = messageFormatterFn((function(  ) {
  return function(d) { return "Datum"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1325022972 = messageFormatterFn((function(  ) {
  return function(d) { return "er zijn " + d["0"] + " resultaten"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b1101186180 = messageFormatterFn((function(  ) {
  return function(d) { return "Er is 1 resultaat"; }
})(), Globalize("nl-NL").pluralGenerator({}));
Globalize.b963432840 = dateToPartsFormatterFn({"2":Globalize("nl-NL").numberFormatter({"raw":"00"}),"4":Globalize("nl-NL").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b2077979208 = dateToPartsFormatterFn({"2":Globalize("nl-NL").numberFormatter({"raw":"00"}),"4":Globalize("nl-NL").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b2023520245 = dateToPartsFormatterFn({"1":Globalize("nl-NL").numberFormatter({"raw":"0"}),"4":Globalize("nl-NL").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.a1148993093 = dateToPartsFormatterFn({"1":Globalize("nl-NL").numberFormatter({"raw":"0"}),"4":Globalize("nl-NL").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b2023838184 = dateToPartsFormatterFn({"2":Globalize("nl-NL").numberFormatter({"raw":"00"}),"4":Globalize("nl-NL").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a725150221 = dateToPartsFormatterFn({"1":Globalize("nl-NL").numberFormatter({"raw":"0"}),"4":Globalize("nl-NL").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b226116168 = dateToPartsFormatterFn({"2":Globalize("nl-NL").numberFormatter({"raw":"00"}),"4":Globalize("nl-NL").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b1969697160 = dateToPartsFormatterFn({"2":Globalize("nl-NL").numberFormatter({"raw":"00"}),"4":Globalize("nl-NL").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b1440202888 = dateToPartsFormatterFn({"2":Globalize("nl-NL").numberFormatter({"raw":"00"}),"4":Globalize("nl-NL").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.a2029875659 = dateToPartsFormatterFn({"1":Globalize("nl-NL").numberFormatter({"raw":"0"}),"4":Globalize("nl-NL").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a1552709144 = dateToPartsFormatterFn({"2":Globalize("nl-NL").numberFormatter({"raw":"00"}),"4":Globalize("nl-NL").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b433596697 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"Z","mon":"M","tue":"D","wed":"W","thu":"D","fri":"V","sat":"Z"}}}});
Globalize.b845301832 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"zondag","mon":"maandag","tue":"dinsdag","wed":"woensdag","thu":"donderdag","fri":"vrijdag","sat":"zaterdag"}}}});
Globalize.b2098547272 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"maart","4":"april","5":"mei","6":"juni","7":"juli","8":"augustus","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b400217560 = dateToPartsFormatterFn({"1":Globalize("nl-NL").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b654953685 = dateToPartsFormatterFn({"1":Globalize("nl-NL").numberFormatter({"raw":"0"}),"2":Globalize("nl-NL").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a1622011830 = dateToPartsFormatterFn({"1":Globalize("nl-NL").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mrt.","4":"apr.","5":"mei","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b1276601965 = dateToPartsFormatterFn({"1":Globalize("nl-NL").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"maart","4":"april","5":"mei","6":"juni","7":"juli","8":"augustus","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.a1137065858 = dateToPartsFormatterFn({"1":Globalize("nl-NL").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"maart","4":"april","5":"mei","6":"juni","7":"juli","8":"augustus","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b1903043746 = dateToPartsFormatterFn({"1":Globalize("nl-NL").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"maart","4":"april","5":"mei","6":"juni","7":"juli","8":"augustus","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b1902358553 = dateToPartsFormatterFn({"1":Globalize("nl-NL").numberFormatter({"raw":"0"})}, {"pattern":"d MMM y","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mrt.","4":"apr.","5":"mei","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b1163576074 = dateToPartsFormatterFn({"1":Globalize("nl-NL").numberFormatter({"raw":"0"})}, {"pattern":"EEEE d MMM","timeSeparator":":","days":{"E":{"4":{"sun":"zondag","mon":"maandag","tue":"dinsdag","wed":"woensdag","thu":"donderdag","fri":"vrijdag","sat":"zaterdag"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mrt.","4":"apr.","5":"mei","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b1283990133 = dateToPartsFormatterFn({"1":Globalize("nl-NL").numberFormatter({"raw":"0"})}, {"pattern":"E d MMM","timeSeparator":":","days":{"E":{"1":{"sun":"zo","mon":"ma","tue":"di","wed":"wo","thu":"do","fri":"vr","sat":"za"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mrt.","4":"apr.","5":"mei","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b584719089 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b1699265457 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.b208603038 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b1331056996 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b1645124433 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b1754899868 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a152597583 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b1590983409 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b1061489137 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b450174430 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a1931422895 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b584770064 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b1681462385 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a1360259471 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.a183066033 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"d"}));
Globalize.b1046360766 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a2049870399 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b897888214 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b7709749 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b1524329995 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b1523644802 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b1781306625 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b905276382 = dateFormatterFn(Globalize("nl-NL").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a1029342654 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.b85203714 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b997984047 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b2120438005 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b31062690 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a1750686419 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a1766659326 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a23078334 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a552572606 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.b1239555439 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b749482658 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a1221364705 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^Z/],["mon",/^M/],["tue",/^D/],["wed",/^W/],["thu",/^D/],["fri",/^V/],["sat",/^Z/]]});
Globalize.a1701935998 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^donderdag/],["wed",/^woensdag/],["sat",/^zaterdag/],["mon",/^maandag/],["tue",/^dinsdag/],["fri",/^vrijdag/],["sun",/^zondag/]]});
Globalize.a448690558 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["8",/^augustus/],["11",/^november/],["12",/^december/],["1",/^januari/],["10",/^oktober/],["3",/^maart/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^mei/]]});
Globalize.b1374720990 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b890757775 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b946104400 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mrt\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^mei/]]});
Globalize.a716173529 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["8",/^augustus/],["11",/^november/],["12",/^december/],["1",/^januari/],["10",/^oktober/],["3",/^maart/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^mei/]]});
Globalize.b1511403268 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["8",/^augustus/],["11",/^november/],["12",/^december/],["1",/^januari/],["10",/^oktober/],["3",/^maart/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^mei/]]});
Globalize.a89731748 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["8",/^augustus/],["11",/^november/],["12",/^december/],["1",/^januari/],["10",/^oktober/],["3",/^maart/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^mei/]]});
Globalize.a90416941 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mrt\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^mei/]]});
Globalize.a573200368 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE d MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^donderdag/],["wed",/^woensdag/],["sat",/^zaterdag/],["mon",/^maandag/],["tue",/^dinsdag/],["fri",/^vrijdag/],["sun",/^zondag/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mrt\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^mei/]]});
Globalize.a708785361 = dateParserFn(Globalize("nl-NL").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E d MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^zo/],["mon",/^ma/],["tue",/^di/],["wed",/^wo/],["thu",/^do/],["fri",/^vr/],["sat",/^za/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mrt\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^mei/]]});
module.exports = Globalize;
